import { Select } from "antd";
import React from "react";
import { useTemplate } from "../../utils/Template";

export default function ButtonPicker(props) {

    const [template, setTemplate] = useTemplate();
    const { value = 1, onChange = () => { } } = props;

    return (
        <>
            <Select value={value} onChange={(e) => onChange(e)} className="color-select" style={{ "width": "100%" }} showSearch >
                <Select.Option value={0} style={{ "padding": "4px 4px" }}>
                    <small>&nbsp;&nbsp;&nbsp; No Style</small>
                </Select.Option>

                {template.buttons.map(item => {
                    return (
                        <Select.Option key={item.id} value={item.id} style={{ "padding": "4px 4px" }}>
                            <small>&nbsp; {item.name}</small>
                        </Select.Option>
                    )
                })}
            </Select>
        </>
    )
}